/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AuthenticationRequest } from '../model/models';
import { User } from '../model/models';
import { UserRole } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AuthServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Login
     * Login with useridentifier and password
     * @param authenticationRequest useridentifier &amp; password of the user for login
     */
    authenticate(authenticationRequest?: AuthenticationRequest, extraHttpRequestParams?: any): Observable<User>;

    /**
     * Get user authorization data
     * Returns user authorization data based on the JWT token in the HTTP-only cookie.
     */
    getAuthData(extraHttpRequestParams?: any): Observable<Array<UserRole>>;

    /**
     * Logout
     * Logout
     */
    logout(extraHttpRequestParams?: any): Observable<{}>;

}
